import Navbar from "../../components/Navbar";
import "./css/faq.css"
import FaqEntries from "../../data/Faq";
import Footer from "../../components/Footer";

const Faq = () => {
    return (
        <main>
            <Navbar/>

            <div className="container faq__container">

                <h1 className="text-cursive faq__header">Q & A</h1>

                <div className="faq__content">
                    {
                        FaqEntries.map((entry) => {
                            return (
                                <div key={entry.id} className="faq__entry">
                                    <h3 className="faq__title">{entry.title.toUpperCase()}</h3>
                                    <p className="faq__text">{entry.content}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <Footer/>
        </main>
    );
};

export default Faq;
